import get from 'lodash/get';
import { Module } from 'vuex';
import { DefineGetters } from 'vuex-type-helper';
import { moment } from '../../app.config';
import { africaOptions } from '../../globals';
import { RootState } from '../index';

const timezone = get(africaOptions, 'formatter.timezone', 'Europe/Copenhagen');

export interface WorkingDaySetting {
    active: boolean;
    start: number | null;
    end: number | null;
}

export interface ModuleState {
    days: { [key: string]: WorkingDaySetting };
}

export interface ModuleGetters {
    isOpenNow: boolean;
}

const state: ModuleState = {
    days: window.africaOptions.officeSchedule,
};

const getters: DefineGetters<ModuleGetters, ModuleState> = {
    isOpenNow({ days }): boolean {
        const now: moment.Moment = (moment as any).tz(new Date(), timezone);
        const todayId: string = now.clone().locale('en').format('ddd').toLowerCase();
        const today: WorkingDaySetting = get(days, todayId, { active: false, start: null, end: null });
        const active: boolean = get(today, 'active', false) === true;
        if (active !== true) {
            return false;
        }
        const start: moment.Moment = now.clone().startOf('day').add(parseInt((get(today, 'start', 0) || '').toString(), 10), 'seconds');
        const end: moment.Moment = now.clone().startOf('day').add(parseInt((get(today, 'end', 0) || '').toString(), 10), 'seconds');
        return now.isBetween(start, end);
    },
};

const module: Module<ModuleState, RootState> = {
    namespaced: true,
    state,
    getters,
};

export default module;



// WEBPACK FOOTER //
// ./src/store/modules/officeSchedule.ts